/**
 * 中文翻译文件 (扁平格式，避免嵌套问题)
 */
export default {
  // 基础词汇
  "language": "语言",
  "title": "送货预约",
  "confirm": "确认预约",

  // 基本信息
  "baseInfo.title": "基本信息",
  "baseInfo.name": "姓名",
  "baseInfo.phone": "联系方式",
  "baseInfo.address": "安装地址",
  "baseInfo.expectDate": "期望上门日期",
  "baseInfo.service": "服务内容",
  "baseInfo.extra": "额外需求",
  "baseInfo.remark": "备注",
  "baseInfo.remarkPlaceholder": "请输入",
  "baseInfo.fillName": "请填写姓名",
  "baseInfo.fillContact": "请填写联系方式",
  "baseInfo.fillAddress": "请填写安装地址",
  "baseInfo.selectService": "请选择服务内容",
  "baseInfo.selectDate": "请选择期望上门日期",

  // 预约相关
  "appointment.title": "预约时间",
  "appointment.warning": "若客户原因配送失败，需扣除40美元",
  "appointment.days.today": "今天",
  "appointment.days.tomorrow": "明天",
  "appointment.days.monday": "周一",
  "appointment.days.tuesday": "周二",
  "appointment.days.wednesday": "周三",
  "appointment.days.thursday": "周四",
  "appointment.days.friday": "周五",
  "appointment.days.saturday": "周六",
  "appointment.days.sunday": "周日",
  "appointment.timeSlot.title": "选择时段",
  "appointment.timeSlot.slot1": "08:00-11:00",
  "appointment.timeSlot.slot2": "10:00-13:00",
  "appointment.timeSlot.slot3": "12:00-15:00",
  "appointment.timeSlot.slot4": "14:00-17:00",
  "appointment.timeSlot.slot5": "17:00-20:00",

  // 联系方式
  "contact.title": "第二联系方式",
  "contact.mobile": "手机号码",
  "contact.email": "邮箱",
  "contact.placeholder": "请输入",

  // 大门信息
  "doorInfo.title": "大门信息",
  "doorInfo.hasDoor": "有大门",
  "doorInfo.noDoor": "无大门",
  "doorInfo.passwordTitle": "大门密码",
  "doorInfo.passwordPlaceholder": "请填写大门密码",
  "doorInfo.passwordRequired": "请填写大门密码",

  // 送货方式
  "delivery.title": "送货摆放方式",
  "delivery.placeholder": "请选择",
  "delivery.photoOptional": "非必选",
  "delivery.photoPlaceholder": "请上传摆放位置照片",
  "delivery.photoUploadSuccess": "照片上传成功",
  "delivery.photoDeleted": "照片已删除",
  "delivery.viewPhoto": "查看照片",
  "delivery.noPhotoAvailable": "暂无图片",
  "delivery.locations.frontPorch": "前门廊",
  "delivery.locations.garage": "车库",
  "delivery.locations.backDoor": "后门",
  "delivery.locations.sideEntrance": "侧门",
  "delivery.locations.buildingLobby": "大楼大厅",

  // 安装信息
  "installation.title": "是否需要安装",
  "installation.yes": "是",
  "installation.no": "否",

  // 上楼信息
  "stairs.title": "是否需要送货上楼",
  "stairs.yes": "是",
  "stairs.no": "否",

  // 成功弹窗
  "successPopup.title": "预约成功",
  "successPopup.appointmentTime": "上门时间",
  "successPopup.cancellationNote": "若客户原因配送失败，需扣除40美元",
  "successPopup.viewDetails": "查看预约详情",

  // 错误提示
  "errors.noTrackingNumber": "未找到有效的追踪号码",
  "errors.networkError": "网络请求失败，请稍后再试",
  "errors.apiError": "获取预约信息失败",
  "errors.selectTimeSlot": "请选择预约时间",

  // 订单详情
  "orderDetail.title": "预约详情",
  "orderDetail.editAppointment": "修改预约",
  "orderDetail.loading": "加载中...",
  "orderDetail.customerService": "致电客服",

  // 评价相关
  "review.title": "客户评价",
  "review.areYouSatisfied": "您对此次安装服务满意吗？",
  "review.satisfied": "满意",
  "review.disatisfied": "不满意",
  "review.pleaseRateService": "请为此次服务评分",
  "review.overallScore": "综合评分",
  "review.workEfficiency": "工作效率",
  "review.communicationExperience": "沟通体验",
  "review.yourImpression": "您对师傅的印象",
  "review.confirmSignature": "确认签字",
  "review.reSign": "重新签字",
  "review.clickSign": "点击签字",
  "review.file": "签字文件",
  "review.comment": "评价",
  "review.enterComment": "请输入评价内容",
  "review.submit": "提交",
  "review.noOrderNo": "订单号缺失",
  "review.selectSatisfaction": "请选择是否满意",
  "review.selectTags": "请选择印象标签",
  "review.selectInteractScore": "请打分沟通评分",
  "review.selectWorkScore": "请打分工作效率",
  "review.selectServiceScore": "请打分综合评分",
  "review.signRequired": "请先签字",
  "review.thanks": "感谢您的评价！",
  "review.scoreUnit": "分",

  // 首页相关
  "index.title": "安装预约",
  "index.flowCardTitle": "预约安装流程",
  "index.prepareCardTitle": "安装前准备",
  "index.step1Title": "提交预约信息",
  "index.step1Desc": "请仔细填写预约信息，按需拍摄并上传真实安装环境照片，帮助技术人员提前了解情况。",
  "index.step2Title": "电工接单/上门前沟通",
  "index.step2Desc": "电工接单后，会与您沟通服务细则并确认服务时间。",
  "index.step3Title": "上门工作",
  "index.step3Desc": "请在技术人员上门前，做好安装前准备工作，有特殊情况及时告知技术人员。",
  "index.step4Title": "完工确认/评价服务",
  "index.step4Desc": "请您随时监督技术人员的工作，完工后确认签字并邀请您对技术人员的服务进行真实评价。",
  "index.prepare1": "确保安装区域整洁整齐，移除可能影响安装的障碍物。",
  "index.prepare2": "如需拆除旧设备，请提前做好备份和数据转移工作。",
  "index.customerService": "客服",
  "index.callHotline": "拨打客服热线",
  "index.nextStep": "下一步",
  "index.noOrderNoTip": "请联系客服获取下单链接",

  // 步骤条相关
  "stepProgress.title": "申请步骤",
  "stepProgress.installDesc": "安装说明",
  "stepProgress.basicInfo": "基本信息",
  "stepProgress.installPosition": "安装位置",
  "stepProgress.circuitInfo": "电路信息",
  "stepProgress.finish": "预约完成",

  // Common words
  "common.cancel": "取消",
  "common.confirm": "确定",
  "common.prev": "上一步",
  "common.next": "下一步",

  // ExtraSelectPopup related keys
  "extra.title": "额外需求",
  "extra.sub": "可多选",
  "extra.confirm": "确定",
  "extra.需要布线": "需要布线",
  "extra.需要拆除旧设备": "需要拆除旧设备",
  "extra.需要打孔": "需要打孔",
  "extra.需要接油机": "需要接油机",
  "extra.需要配件适配": "需要配件适配",

  // ServiceSelectPopup related keys
  "service.title": "选择服务内容",
  "service.confirm": "确定",

  // InstallationPosition related keys
  "install.title": "安装位置",
  "install.position": "安装位置",
  "install.wallType": "墙面类型",
  "install.select": "请选择",
  "install.photo": "安装位置照片",
  "install.photoTip": "请尽可能多角度拍摄安装位置，便于技术人员评估",
  "install.concrete": "混凝土",
  "install.wood": "木板",
  "install.wall": "墙面",
  "install.ground": "地面",
  "install.onlyJpgPng": "仅支持 JPG/PNG 格式",
  "install.maxSize": "图片大小不能超过5MB",
  "install.fileTypeError": "文件类型错误",
  "install.uploadFail": "上传失败",
  "install.selectWallType": "请选择墙面类型",
  "install.selectPosition": "请选择安装位置",
  "install.uploadPhoto": "请上传安装位置照片",

  // CircuitInfo related keys
  "circuit.title": "电路信息",
  "circuit.mainBox": "主电箱",
  "circuit.mainBoxTip": "需拍摄到最内侧开关，用于评估电力供应情况。",
  "circuit.meter": "电表",
  "circuit.wire": "电线预留及周边环境",
  "circuit.distance": "配电箱到smart panel的距离",
  "circuit.distanceTip": "请拍摄或上传一段视频，帮助技术人员评估安装难度和所需材料",
  "circuit.submit": "提交信息",
  "circuit.onlyJpgPng": "仅支持 JPG/PNG 格式",
  "circuit.maxSize": "图片大小不能超过15MB",
  "circuit.onlyVideo": "仅支持视频文件",
  "circuit.maxVideoSize": "视频大小不能超过150MB",
  "circuit.fileTypeError": "文件类型错误",
  "circuit.uploadFail": "上传失败",
  "circuit.uploadMainBox": "请上传主电箱照片",
  "circuit.uploadMeter": "请上传电表照片",
  "circuit.uploadWire": "请上传电线预留及周边环境照片",
  "circuit.uploadDistance": "请上传配电箱到smart panel的距离视频",
  "circuit.submitSuccess": "提交成功",
  "circuit.networkError": "网络异常，提交失败",

  // OrderSuccess related keys
  "orderSuccess.title": "预约完成",
  "orderSuccess.success": "预约成功",
  "orderSuccess.orderId": "预约单号：",
  "orderSuccess.address": "安装地址",
  "orderSuccess.name": "姓名",
  "orderSuccess.phone": "电话",
  "orderSuccess.expectTime": "期望上门时间",
  "orderSuccess.customerService": "客服",
  "orderSuccess.callHotline": "拨打客服热线",

  // DatePickerPopup related keys
  "datePicker.title": "期望上门时间",
  "datePicker.dateTitle": "期望日期",
  "datePicker.dateTip": "日期可多选，供技术人员调配时间",
  "datePicker.selected": "已选：",
  "datePicker.to": "至",
  "datePicker.period": "期间",
  "datePicker.timeLabel": "选择时段",
  "datePicker.time1": "08:00-12:00",
  "datePicker.time2": "13:00-17:00",
  "datePicker.time3": "18:00-21:00",
  "datePicker.month": "月",
  "datePicker.day": "日"
}; 